
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias/tag/[tag]",
      function () {
        return require("private-next-pages/noticias/tag/[tag].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias/tag/[tag]"])
      });
    }
  